module.exports = __webpack_public_path__ + "static/media/NotificationDark.63f5f961.svg";